import React from "react";
import { Button, ButtonGrey } from "../../style/Button";
import "./Bill.css";
import AdvertiserCard from "../common/card";
import { Checkbox, Grid } from "@material-ui/core";
import Horizonatl from "../../assets/Ads/Horizontal.jpeg";

export class Billing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {},
      check1: false,
      check2: false,
      check3: false,
      check4: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.restoreView = this.restoreView.bind(this);
    this.update = this.update.bind(this);
    this.restoreView();
  }

  handleChange = event => {
    this.setState({ check1: !this.state.check1 });
    if (event.target.checked) {
      if (this.state.value) {
        this.state.value.discount = true;
        window.sessionStorage.setItem("med", JSON.stringify(this.state.value));
      }

    }

  }

  restoreView = () => {
    if (this.props.location.state) {
      this.state.value = this.props.location.state;
      window.sessionStorage.setItem("med", JSON.stringify(this.state.value));
    } else {
      this.state.value = JSON.parse(window.sessionStorage.getItem("med"));
    }
  };

  update = () => {
    this.props.history.push({
      pathname: "/People/Prescription",
    });
  };

  render() {
    return (
      <Grid container className="billing-page">
        <Grid item md={12} xs={12} lg={`${this.props.verticalCreative ? 9 : 12}`}>
          <section
            class=" mt-3 custom-radius border border-secondary "
            style={{
              paddingBottom: "0px !important",
              backgroundColor: "white",
            }}
          >
            <nav class="navbar navbar-expand-lg  custom-radius  navbar-dark theme-color p-0">
              <a
                class="navbar-brand  ms-4 fw-bold"
                href="#"
                style={{
                  fontSize: "15.14px",
                  fontWeight: 600,
                  fontFamily:
                    "work sans",
                }}
              >
                Selected Mediation
              </a>

              <span
                class="collapse navbar-collapse"
                id="navbarNav"
                style={{
                  fontSize: "11.5px",
                  color: "white",
                  fontWeight: 600,
                  fontFamily:
                    "work sans",
                }}
              >
                <b>
                  <span
                    style={{
                      position: "absolute",
                      right: "120px",
                      marginTop: "-8px",
                    }}
                  >
                    Monograph
                  </span>{" "}
                  <span
                    style={{
                      marginTop: "-8px",
                      position: "absolute",
                      right: "40px",
                    }}
                  >
                    {" "}
                    Leaflet
                  </span>
                </b>
              </span>
            </nav>
            <nav
              class="navbar navbar-expand-lg border    navbar-primary bg-white "
              style={{ paddingTop: "2px", paddingBottom: "2px" }}
            >
              <a
                style={{
                  fontSize: "15.14px",
                  fontWeight: 600,
                  fontFamily:
                    "work sans",
                }}
                class="navbar-brand  ms-4"
                href="#"
              >
                {this.state.value.medicationName}{" "}
              </a>
              <div
                class="collapse navbar-collapse"
                id="navbarNav"
                style={{ marginRight: "35px" }}
              >
                <ul
                  class="navbar-nav ms-auto "
                  style={{ fontSize: "14px", color: "#606060" }}
                >
                  <li class="nav-item" style={{ padding: 5 }}>
                    <b
                      style={{
                        fontWeight: 700,
                        fontFamily:
                          "work sans",
                      }}
                    >
                      Type:{" "}
                    </b>{" "}
                    <span
                      class="text-secondary"
                      style={{
                        fontWeight: 500,
                        fontFamily:
                          "work sans",
                      }}
                    >
                      Brand Rx
                    </span>
                  </li>
                  <li class="nav-item" style={{ padding: 5 }}>
                    <b
                      style={{
                        fontWeight: 700,
                        fontFamily:
                          "work sans",
                      }}
                    >
                      Formulary:{" "}
                    </b>{" "}
                    <span
                      class="text-secondary"
                      style={{
                        fontWeight: 500,
                        fontFamily:
                          "work sans",
                      }}
                    >
                      Un
                    </span>
                  </li>
                  <li
                    class="nav-item"
                    style={{
                      padding: 5,
                      fontWeight: 500,
                      fontFamily:
                        "work sans",
                    }}
                  >
                    View Coverage
                  </li>
                </ul>
              </div>
            </nav>
            <nav
              class="navbar navbar-expand-lg border   navbar-primary bg-white "
              style={{ paddingTop: "4px", paddingBottom: "4px" }}
            >
              <div class="collapse navbar-collapse" id="navbarNav">
                <ul
                  class="navbar-nav offset-10 position-relative"
                  style={{ fontSize: "13px", right: "0px" }}
                >
                  <li class="nav-item " style={{ marginTop: "-9px" }}>
                    <div class="nav-link text-dark ">
                      <Checkbox
                        className="clickable2"
                        type="checkbox"
                        onChange={this.handleChange}
                      />
                    </div>
                  </li>
                  <li class="nav-item ms-2">
                    <div
                      class="nav-link text-dark"
                      style={{
                        width: "32px",
                        height: "35px",
                        marginTop: "-3px",
                        fontSize: "20px",
                      }}
                    >
                      <i
                        class="far fa-money-bill-alt"
                        style={{ color: "#008576" }}
                      ></i>
                    </div>
                  </li>
                  <li class="nav-item ms-3">
                    <div
                      class="nav-link "
                      style={{
                        color: "#008576",
                        fontSize: "12px",
                        fontWeight: 500,
                        marginLeft: "7px",
                        fontFamily:
                          "work sans",
                      }}
                    >
                      Coupon/Guide <br />
                      Available
                    </div>
                  </li>
                  {this.state.check1 && (
                    <span
                      style={{ marginLeft: "-110%", marginTop: "30px" }}
                    ></span>
                  )}
                </ul>
              </div>
            </nav>

            <nav class="navbar navbar-expand-lg   navbar-dark theme-color     p-0  ">
              <a
                class="navbar-brand  ms-4 fw-bolder"
                style={{
                  fontSize: "15.14px",
                  fontWeight: 600,
                  fontFamily:
                    "work sans",
                }}
                href="#"
              >
                Sig Information
              </a>
            </nav>
            <Grid container className="p-4">
              <Grid item md={12}>
                <div class="d-flex justify-content-evenly flex-wrap-mob marginTabs">
                  <button
                    type="button"
                    class="btn text-dark rounded-2 theme-font"
                  >
                    Action
                  </button>
                  <button
                    type="button"
                    class="btn text-dark rounded-2 theme-font"
                  >
                    Amount
                  </button>
                  <button
                    type="button"
                    class="btn text-dark rounded-2 theme-font"
                  >
                    Dosage Form
                  </button>
                  <button
                    type="button"
                    class="btn text-dark rounded-2 theme-font"
                  >
                    Route
                  </button>
                  <button
                    type="button"
                    class="btn text-dark rounded-2 theme-font"
                  >
                    Frequency
                  </button>
                </div>
                <div
                  class="d-flex justify-content-evenly flex-wrap-mob marginTabs"
                  style={{ marginTop: "15px" }}
                >
                  <select
                    name=""
                    id=""
                    class="form-select theme-font"
                    aria-label="Default select example"
                  >
                    <option value="">Take</option>
                    <option value=""></option>
                  </select>
                  <select
                    name=""
                    id=""
                    class="form-select theme-font"
                  >
                    <option value="">{this.state.value.amount}</option>
                  </select>
                  <select
                    name=""
                    id=""
                    class="form-select theme-font"
                  >
                    <option value="">{this.state.value.dosageForm}</option>
                  </select>
                  <select
                    name=""
                    id=""
                    class="form-select theme-font"
                  >
                    <option value="">{this.state.value.route}</option>
                  </select>
                  <select
                    name=""
                    id=""
                    class="form-select theme-font"
                  >
                    <option value="">{this.state.value.frequency}</option>
                  </select>
                </div>
                <div class="mb-3" style={{ marginTop: "15px" }}>
                  <Grid container>
                    <Grid md={12} xs={12}>
                      <Grid container>
                        <Grid item md={2} xs={12}>
                          <label
                            for="add"
                            class="col-form-label theme-font"
                            style={{
                              maxWidth: "max-content",
                              fontWeight: 600,
                              fontFamily:
                                "work sans",
                              color: "#58595B",
                              fontSize: "14px",
                              paddingRight: "0px",
                            }}
                          >
                            Addtional Direction:
                          </label>
                        </Grid>
                        <Grid item md={10} xs={12}>
                          <div >
                            <input
                              style={{
                                maxWidth: "100%",
                                minWidth: "100%",
                                marginLeft: "0px",
                                fontFamily:
                                  "work sans",
                                fontSize: "14px",
                                fontWeight: 600,
                                color: "#58595B",
                              }}
                              type="text"
                              class="form-control theme-font "
                              id="add"
                              value=""
                            />
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
                <div className="mb-0">
                  <Grid container spacing={2}>
                    <Grid item md={6} xs={12}>
                      <Grid container spacing={2} className="mb-3" >
                        <Grid item md={4} xs={12}>
                          <label
                            className="theme-font"
                            style={{
                              maxWidth: "100%",
                              fontWeight: 600,
                              fontFamily:
                                "work sans",
                              color: "#58595B",
                              fontSize: "14px",
                              paddingRight: "0px",
                            }}
                          >
                            Patient Direction: :
                          </label>
                        </Grid>
                        <Grid item md={8} xs={12}>
                          <textarea
                            style={{
                              maxWidth: "100%",
                              minWidth: "fit-content",
                              fontFamily:
                                "work sans",
                              fontSize: "14px",
                              fontWeight: 400,
                              color: "#58595B",
                            }}
                            name=""
                            id=""
                            cols="30"
                            rows="5"
                            class="form-control theme-font"
                          >
                            {this.state.value.patientDirection}
                          </textarea>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item md={6} xs={12} >
                      <Grid container spacing={2} className="mb-3" >
                        <Grid item md={4} xs={12}>
                          <label
                            for=""
                            class="text-secondary theme-font"
                            style={{
                              maxWidth: "100%",
                              fontWeight: 600,
                              fontFamily:
                                "work sans",
                              color: "#58595B",
                              fontSize: "14px",
                              paddingRight: "0px",
                            }}
                          >
                            Day Supply:
                          </label>
                        </Grid>
                        <Grid item md={8} xs={12}>
                          <input
                            style={{
                              width: "100%",
                              display: "block",
                              fontSize: "12.7px",
                              fontFamily:
                                "work sans",
                              fontSize: "14px",
                              fontWeight: 600,
                              color: "#58595B",
                            }}
                            type="text"
                            class="form-control"
                            value={this.state.value.daysSupply}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} className="mb-3">
                        <Grid item md={4} xs={12}>
                          <label
                            for=""
                            class="text-secondary theme-font"
                            style={{
                              maxWidth: "100%",
                              fontWeight: 600,
                              fontFamily:
                                "work sans",
                              color: "#58595B",
                              fontSize: "14px",
                              paddingRight: "0px",
                            }}
                          >
                            Dispence Amount:
                          </label>
                        </Grid>
                        <Grid item md={8} xs={12}>
                          <input
                            style={{
                              width: "100%",
                              display: "inline",
                              fontSize: "12.7px",
                              fontFamily:
                                "work sans",
                              fontSize: "14px",
                              fontWeight: 400,
                              color: "#58595B",
                            }}
                            type="text"
                            class="form-control"
                            value={this.state.value.dispenseAmount}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
                <div class="mb-3">
                  <Grid container spacing={2}>
                    <Grid item md={2} xs={12}>
                      <label
                        class="theme-font col-form-label"
                        style={{
                          maxWidth: "100%",
                          fontWeight: 600,
                          fontFamily:
                            "work sans",
                          color: "#58595B",
                          fontSize: "14px",
                          paddingRight: "0px",
                        }}
                      >
                        Problem/Dx:
                      </label>
                    </Grid>
                    <Grid item md={10} xs={12}>
                      <select
                        style={{
                          maxWidth: "100%",
                          minWidth: "100%",
                          fontFamily:
                            "work sans",
                          fontSize: "14px",
                          fontWeight: 600,
                          color: "#58595B",
                        }}
                        name=""
                        id=""
                        class="form-select theme-font"
                      >
                        <option value="">1</option>
                      </select>
                    </Grid>
                  </Grid>
                </div>
                <div class="mb-3">
                  <Grid container spacing={2}>
                    <Grid item md={6} xs={12}>
                      <Grid container spacing={2}>
                        <Grid item md={4} xs={12}>
                          <label
                            class="col-form-label theme-font"
                            style={{
                              maxWidth: "100%",
                              fontWeight: 600,
                              fontFamily:
                                "work sans",
                              color: "#58595B",
                              fontSize: "14px",
                              paddingRight: "0px",
                            }}
                          >
                            Pharmacy Notes:
                          </label>
                        </Grid>
                        <Grid item md={8} xs={12}>
                          <textarea
                            style={{
                              maxWidth: "100%",
                              minWidth: "fit-content",
                              fontFamily:
                                "work sans",
                              fontSize: "14px",
                              fontWeight: 400,
                              color: "#58595B",
                            }}
                            name=""
                            id=""
                            cols="30"
                            rows="3"
                            class="form-control theme-font"
                          >
                            {this.state.value.pharmacyNote}
                          </textarea>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <Grid container className="p-2" >
                        <Grid item md={12} xs={12}>
                          <Checkbox
                            style={{ padding: "0px", margin: "-5px" }}
                            type="checkbox"
                            value=""
                            onChange={() =>
                              this.setState({ check2: !this.state.check2 })
                            }
                          />
                          <label
                            for=""
                            class="text-secondary ms-3 theme-font"
                            style={{
                              maxWidth: "max-content",
                              fontWeight: 600,
                              color: "#58595B",
                              fontSize: "14px",
                              paddingRight: "0px",
                              paddingLeft: "15px",
                              fontFamily:
                                "work sans",
                            }}
                          >
                            Store Sig & Add to Prescriber’s List
                          </label>
                        </Grid>
                        <Grid item md={12} xs={12}>
                          <Checkbox
                            style={{ padding: "0px", margin: "-5px" }}
                            className="clickable2"
                            type="checkbox"
                            value=""
                            onChange={() =>
                              this.setState({ check3: !this.state.check3 })
                            }
                          />
                          <label
                            for=""
                            class="text-secondary ms-3 theme-font"
                            style={{
                              maxWidth: "max-content",
                              fontWeight: 600,
                              color: "#58595B",
                              fontSize: "14px",
                              paddingRight: "0px",
                              paddingLeft: "15px",
                              fontFamily:
                                "work sans",
                            }}
                          >
                            DAW/DNS
                          </label>
                        </Grid>
                        {this.state.check3 && <span></span>}
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            </Grid>
          </section>
          <div className={` ${this.props.reactCreative ? "" : "noCreative"}`}>
            <Grid container spacing={2}>

              {this.props.reactCreative &&
                <Grid item md={3} xs={12}>
                  <div className="mobileCss mobCenter" style={{ marginTop: "10px" }}>
                    <div  className="responsiveMargin" style={{ maxWidth: '300px', minHeight: '250px', }}>
                      <iframe
                        title="iframe"
                        srcDoc={this.props.reactCreative}
                        style={{
                          width: '100%',
                          height: '100%',
                          maxWidth: '100%',
                          minHeight: '250px',
                          marginBottom: "30px"
                        }}
                        frameBorder="0"
                        scrolling="no"
                      />
                    </div>
                  </div>
                </Grid>
              }

              <Grid item md={`${this.props.reactCreative ? 9 : 12}`} xs={12}>
                <div className="biilingCoupons">
                  <nav
                    class="navbar navbar-expand-lg navbar-dark theme-color p-0"
                    style={{
                      marginTop: "7px",
                      minWidth: "100%",
                    }}
                  >
                    <a
                      class="navbar-brand  ms-4 fw-bold"
                      href="#"
                      style={{
                        fontSize: "15.14px",
                        fontFamily:
                          "work sans",
                        fontWeight: 600,
                      }}
                    >
                      Alternative Medication
                    </a>
                  </nav>
                  <nav
                    class="navbar navbar-expand-lg border    navbar-primary bg-white p-4"
                    style={{ marginLeft: "0px", minWidth: "100%" }}
                  >
                    <Grid container spacing={2}>
                      <Grid item md={6} xs={12}>
                        <a
                          style={{ fontSize: "15.14px", fontWeight: 600 }}
                          class="navbar-brand  mb-4"
                          href="#"
                        >
                          {this.state.value.alternativeMedication}{" "}
                        </a>
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <div
                          class="navbar-collapse"
                          id="navbarNav"
                        >
                          <ul
                            class="navbar-nav ms-auto "
                            style={{ fontSize: "14px", color: "#606060" }}
                          >
                            <li class="nav-item" style={{ padding: 5 }}>
                              <b
                                style={{
                                  fontWeight: 700,
                                  fontFamily:
                                    "work sans",
                                }}
                              >
                                Type:{" "}
                              </b>{" "}
                              <span
                                class="text-secondary"
                                style={{
                                  fontWeight: 500,
                                  fontFamily:
                                    "work sans",
                                }}
                              >
                                Brand Rx
                              </span>
                            </li>
                            <li class="nav-item" style={{ padding: 5 }}>
                              <b
                                style={{
                                  fontWeight: 700,
                                  fontFamily:
                                    "work sans",
                                }}
                              >
                                Formulary:{" "}
                              </b>{" "}
                              <span
                                class="text-secondary"
                                style={{
                                  fontWeight: 500,
                                  fontFamily:
                                    "work sans",
                                }}
                              >
                                Un
                              </span>
                            </li>
                            <li
                              class="nav-item"
                              style={{
                                padding: 5,
                                fontWeight: 500,
                                fontFamily:
                                  "work sans",
                              }}
                            >
                              View Coverage
                            </li>
                          </ul>{" "}
                        </div>
                      </Grid>
                    </Grid>


                  </nav>
                  <nav
                    class="navbar navbar-expand-lg border   navbar-primary bg-white "
                    style={{
                      minWidth: "100%",
                      borderBottom: "none",
                    }}
                  >
                    <div class="collapse navbar-collapse" id="navbarNav">
                      <ul
                        class="navbar-nav offset-10 position-relative"
                        style={{ fontSize: "13px", right: "0px" }}
                      >
                        <li class="nav-item " style={{ marginTop: "-2px" }}>
                          <Checkbox
                            className={
                              this.state.value.alternativeMedication !== "NA" &&
                              "clickable2"
                            }
                            type="checkbox"
                            value=""
                            disabled={
                              this.state.value.alternativeMedication === "NA"
                            }
                            onChange={
                              this.state.value.alternativeMedication !== "NA"
                                ? () =>
                                  this.setState({ check4: !this.state.check4 })
                                : () => { }
                            }
                          />
                          {/* onChange={this.handleChange} */}
                        </li>
                        <li class="nav-item ms-2">
                          <div
                            class="nav-link text-dark"
                            style={{
                              width: "32px",
                              height: "35px",
                              marginTop: "-3px",
                              fontSize: "20px",
                            }}
                          >
                            <i
                              class="far fa-money-bill-alt"
                              style={{
                                color:
                                  this.state.value.alternativeMedication !== "NA"
                                    ? "#008576"
                                    : "e7e7e7",
                              }}
                            ></i>
                          </div>
                        </li>
                        <li class="nav-item ms-3">
                          <div
                            class="nav-link "
                            style={{
                              color:
                                this.state.value.alternativeMedication !== "NA"
                                  ? "#008576"
                                  : "e7e7e7",
                              fontSize: "10px",
                              fontWeight: 500,
                              marginLeft: "7px",
                              fontFamily:
                                "work sans",
                            }}
                          >
                            Coupon/Guide <br />
                            Available
                          </div>
                        </li>
                      </ul>
                    </div>
                  </nav>
                  <div className="text-right mt-15 upadatedSection">
                    <Button
                      height="fit-content"
                      className="billing-btn-outline md-ml-15"
                    >
                      Close
                    </Button>
                    <Button
                      height="fit-content"
                      className="billing-btn-primary"
                      onClick={this.update}
                    >
                      Update
                    </Button>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>
        {
          this.props.verticalCreative &&
          <Grid md={12} lg={3} xs={12}>
            <div className="text-right  mt-3 rightIframe d-flex justify-content-end">
              <div  className='responsiveMargin' style={{ maxWidth: '300px', minHeight: '600px',}}>
                <iframe
                  title="iframe"
                  srcDoc={this.props.verticalCreative}
                  style={{
                    width: '100%',
                    height: '100%',
                    maxWidth: '100%',
                    minHeight: '600px',
                    marginBottom: "30px"
                  }}
                  frameBorder="0"
                  scrolling="no"
                />
              </div>
            </div>
          </Grid>

        }
      </Grid>
    );
  }
}
//Billing;
